import BaseModel from './BaseModel';
import ModelArray from './ModelArray';
import Experience from './Experience';
import VistaDate from './VistaDate';
import Flag from './Flag';
import RegionService from '../service/region-service'


export default class MovieSession extends BaseModel {

    constructor(data) {
        super();
        this.id = data.id;
        this.cinema_id = data.cinema_id,
        this.experiences = data.experiences ? new ModelArray(data.experiences,Experience) : [];
        this.flags = data.flags ? new ModelArray(data.flags,Flag) : [];
        this.screen_name = data.screen_name;
        this.seats_available = data.seats_available;
        this.show_time = new VistaDate(data.show_time);
        this.time_tag = data.time_tag;
        this.cinema = {};
        if(data.cinema_id){
            RegionService.getCinema(data.cinema_id).then((c)=>{
                this.cinema = c;
            });
        }
    }

    get experiencesString(){
        return this.experiences.map((e)=>e.name).join(' ')
    }

}


// WEBPACK FOOTER //
// ../hasta-la-vista-middleware-api/src/model/MovieSession.js